import { Avatar, Box, Button, Card, CardContent, CircularProgress, Container, createTheme, CssBaseline, Dialog, DialogContent, DialogTitle, Divider, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Slide, TextField, ThemeProvider, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import React, { useEffect, useState } from "react";
import { getOneByRef } from "../../services/getOneByRef";
import { LoadingDialog } from "../modules/dialogs/LoadingDialog";
import Swal from "sweetalert2";
import { getFormasPago } from "../../helpers/getFacturaCats";
import moment from "moment";
import { updateDataExpociencias22 } from "../../services/updateDataExpociencias22";
import { uploadFile } from "../../services/uploadFile";
import { renderToString } from 'react-dom/server';
import { setEmailBodyExpocienciasPagoEst } from "../../helpers/setEmailBodyExpocienciasPagoEst";
import { sendEmail } from "../../services/sendEmail";
import { CustomDialog } from "../modules/dialogs/CustomDialog";


export const ExpocienciasEtapaEstatal = () => {

    // state para las formas de pago en la seccion de agregar comprobante
    const [formasDePago, setFormasDePago] = useState([]);

    // state para los valores del registro que se recupera
    const [formValues, setFormValues] = useState({
        asesorNombres: "",
        asesorApellidos: "",
        asesorCorreo: "",
        asesorTelefono: "",
        asesorTallaCamiseta: "",
        instNombre: "",
        instDomicilio: "",
        instMunicipio: "",
        proyTitulo: "",
        proyCategoria: "",
        proyArea: "",
        proyResumen: "",
        participacion: "",
        est1NombreCompleto: "",
        est1Correo: "",
        est1Telefono: "",
        est1Edad: "",
        est1Sexo: "",
        est1TallaCamiseta: "",
        est2NombreCompleto: "",
        est2Correo: "",
        est2Telefono: "",
        est2Edad: "",
        est2Sexo: "",
        est2TallaCamiseta: "",
        est3NombreCompleto: "",
        est3Correo: "",
        est3Telefono: "",
        est3Edad: "",
        est3Sexo: "",
        est3TallaCamiseta: "",
        requiereFactura: false,
        factNombre: "",
        factRFC: "",
        factCP: "",
        factUsoCFDI: "",
        factRegimenFiscal: "",
        comentarios: "",
        refBancaria: "",
        compPago: "",
        compPagoEst: "",
        claveProyRec: "",
        fechaRegistro: "",
        fechaPago: "",
        fechaPagoEst: "",
    });
    const {
        asesorNombres,
        asesorApellidos,
        asesorCorreo,
        asesorTelefono,
        asesorTallaCamiseta,
        instNombre,
        instDomicilio,
        instMunicipio,
        proyTitulo,
        proyCategoria,
        proyArea,
        proyResumen,
        participacion,
        est1NombreCompleto,
        est1Correo,
        est1Telefono,
        est1Edad,
        est1Sexo,
        est1TallaCamiseta,
        est2NombreCompleto,
        est2Correo,
        est2Telefono,
        est2Edad,
        est2Sexo,
        est2TallaCamiseta,
        est3NombreCompleto,
        est3Correo,
        est3Telefono,
        est3Edad,
        est3Sexo,
        est3TallaCamiseta,
        requiereFactura,
        factNombre,
        factRFC,
        factCP,
        factUsoCFDI,
        factRegimenFiscal,
        comentarios,
        refBancaria,
        compPago,
        compPagoEst,
        claveProyRec,
        fechaRegistro,
        fechaPago,
        fechaPagoEst,
    } = formValues;

    // state para los detalles que ingresa el usuario
    const [detalles, setDetalles] = useState({
        formaPago: "",
        importe: ""
    });
    const { formaPago, importe } = detalles;
    const handleDetallesChange = ({ target }) => {
        console.log(target.name, target.value);
        setDetalles({
            ...detalles,
            [target.name]: target.value,
        });
    };

    // state para saber si la referencia es valida
    const [isRefValid, setIsRefValid] = useState(false);

    // state para el cuadro de "cargando informacion"
    const [isLoadingData, setIsLoadingData] = useState(false);

    // state de la referencia con la que se consulta al inicio
    const [referencia, setReferencia] = useState('');

    // state para el fileupload
    const [file, setFile] = useState({ file: '' });
    const setFileState = (e) => {    
        setFile({ file: e.target.files[0] });    
    };

    // state para indicar si el formulario esta enviandose o no
    const [sendingForm, setSendingForm] = useState(false);
    // Waiting Dialog
    const handleCloseSendingForm = (_, reason) => {
        if (reason !== 'backdropClick') {
            setSendingForm(false);
        }
    };
    
    const handleReferenciaChange = ({target}) => {

        const refValue = target.value;
        // const refLength = target.value.length;
        setReferencia(refValue);

        if (refValue.length === 19) {
            // console.log(refValue);
            getRecord(refValue);

        } else {
            setIsRefValid(false);
        }
    }
    
    const getRecord = async(refValue) => {

        setIsLoadingData(true);
        const resultGetByRef = await getOneByRef({ 
            ref:refValue, 
            apiName:"expociencias22" 
        });
        // console.log(resultGetByRef);

        setIsLoadingData(false);
        if (resultGetByRef.exito === 0) {
            Swal.fire({
                title:'El numero no existe.',
                text:'Por favor confirma la información.',
                icon: 'warning',
            });
            return false;
        }

        // // Establecemos la fecha actual en su campo
        const dateNow = moment().format('YYYY-MM-DDTHH:mm:ss');
        resultGetByRef.data[0].fechaPagoEst = dateNow;
        
        // 'seteamos' el state
        setFormValues( resultGetByRef.data[0] );
        
        setIsRefValid(true); // muestra el div
    }


    // Validar el formumario
    const isFormValid = () => {

        // No ha indicado ningun archivo
        if ( file.file === '' ) {
            Swal.fire("Agregar documento.", `Por favor selecciona un archivo como comprobante.`, "error");
            return false;
        }

        // Indico archivo pero no es un PDF
        const fullName = file.file.name;
        const fileExt = fullName.substring( fullName.lastIndexOf('.') + 1 ).toUpperCase();
        if ( file.file !== '' && fileExt !== 'PDF' ) {
            Swal.fire("Documento incorrecto.", `El comprobante debe ser un archivo PDF.`, "error");
            return false;
        }

        // No ha indicado ninguna forma de pago
        if ( formaPago === '' ) {
            Swal.fire("Indicar la forma de pago.", `Los campos marcados con [ * ] son obligatorios.`, "error");
            return false;
        }

        // Importe obligatorio
        if ( importe <= 0 ) {
            Swal.fire("Indicar importe.", "Los campos marcados con [ * ] son obligatorios.", "error");
            return false;
        }

        return true;
    }

    // Procesar la info
    const isDataProcessed = async() => {

        // - actualizar en db
        const saveResult = await updateDataExpociencias22(formValues);
        console.log(saveResult);
        if (saveResult.exito === 0) {
            return false;
        }

        // - subir archivo en PDF
        const fileName = `${refBancaria}_pagoEst.pdf`
        const resultUpload = await uploadFile({file, fileName});
        console.log(resultUpload);
        if (resultUpload.exito === 0) {
            return false;
        }

        // - enviar correo
        const urlFile = `https://eventos.cibnor.mx/registro/apiServiciosSIARF/${resultUpload.data}`;
        const msgbody = renderToString( setEmailBodyExpocienciasPagoEst(formValues, urlFile) );
        const emailResult = await sendEmail({
            // "toemail": asesorCorreo,
            "toemail": "jorgecollins@hotmail.com",
            "subject": "[Expociencias 2022] Comprobante estatal",
            "message": msgbody,
            "replyto": "expociencias@cibnor.mx",
            "tocc": process.env.REACT_APP_TOCC_EXPOCIENCIAS22,
            "tobcc": process.env.REACT_APP_TOBCC_EXPOCIENCIAS22,
        });
        console.log(emailResult);
        if (emailResult.exito === 0) {
            return false;
        }


        // - ingresar la solicitud de factura
        if (formValues.requiereFactura === 'true') {

            const values = {
                fecha: formValues.fechaPago,
                nombreCliente: formValues.factNombre,
                rfcCliente: formValues.factRFC,
                codigoPostal: formValues.factCP,
                telefonoCliente: formValues.asesorTelefono,
                correoElectronico: formValues.asesorCorreo,
                correoEvento: "expociencias@cibnor.mx",
                regimenFiscalID: formValues.factRegimenFiscal,
                proyecto: formValues.claveProyRec,
                usoCFDI: formValues.factUsoCFDI,
                envioSolicitud: "eventos",
                solicitanteID: 494,
                ejercicio: moment().format("YYYY"),
                quienRegistro: 494,
                importe: importe,
                formaPago: detalles.formaPago,
                NumeroRegistro: formValues.refBancaria,
                archivoPDF: urlFile,
            };
            console.log(values);
        }

        return true;
    }
    
    // al presionar "enviar"
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        console.log(formValues);

        // No paso la validacion, deten el procesamiento
        if ( !isFormValid() ) {
            return false;
        }
 
        // Se muestra el dialogo de enviando formulario
        setSendingForm(true);

        // Procesa la info
        const AllOk = await isDataProcessed();
        console.log(AllOk);
        setSendingForm(false);
        if ( AllOk ) {
            let timerInterval
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                title: "Sus datos han sido recibidos exitosamente.",
                text: 'Consulte su correo electrónico para más información.',
                icon: 'success',
                html: 'Redireccionado a la pagina del evento en <b></b> segundos.',
                timer: 20000,
                timerProgressBar: true,
                didOpen: () => {
                    Swal.showLoading()
                    const b = Swal.getHtmlContainer().querySelector('b')
                    timerInterval = setInterval(() => {
                        b.textContent = Math.round( Swal.getTimerLeft()/1000 )
                    }, 100)
                },
                willClose: () => {
                    clearInterval(timerInterval)
                }
            }).then((result) => {
                if (result.dismiss === Swal.DismissReason.timer) {
                    window.location.replace('https://www.cibnor.gob.mx/eventos-cibnor/3180-expociencias-2022');
                }
            }); 
        } else {
            await sendEmail({
                "toemail": "eventos@cibnor.mx",
                "subject": "[Expociencias 2022] Error",
                "message": formValues,
            });

            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                title: "Sucedío un error en el servidor...",
                text: 'Disculpe el inconveniente.',
                icon: 'error',
                confirmButtonText: 'Ir al sitio web del evento',
                footer: 'Ya se ha notificado al area correspondiente sobre su situación.'
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.replace('https://www.cibnor.gob.mx/eventos-cibnor/3180-expociencias-2022');
                }
            }); 
        }

        console.log(
            asesorNombres,
            asesorApellidos,
            asesorCorreo,
            asesorTelefono,
            asesorTallaCamiseta,
            instNombre,
            instDomicilio,
            instMunicipio,
            proyTitulo,
            proyCategoria,
            proyArea,
            proyResumen,
            participacion,
            est1NombreCompleto,
            est1Correo,
            est1Telefono,
            est1Edad,
            est1Sexo,
            est1TallaCamiseta,
            est2NombreCompleto,
            est2Correo,
            est2Telefono,
            est2Edad,
            est2Sexo,
            est2TallaCamiseta,
            est3NombreCompleto,
            est3Correo,
            est3Telefono,
            est3Edad,
            est3Sexo,
            est3TallaCamiseta,
            requiereFactura,
            factNombre,
            factRFC,
            factCP,
            factUsoCFDI,
            factRegimenFiscal,
            comentarios,
            refBancaria,
            compPago,
            compPagoEst,
            claveProyRec,
            fechaRegistro,
            fechaPago,
            fechaPagoEst
        );
    }

    useEffect(() => {
        const setInitialValues = async() => {
            
            const formasDePago = await getFormasPago();
            setFormasDePago(formasDePago);

        };
        setInitialValues();
    }, []) 
    

    return (
        <ThemeProvider theme={createTheme()}>
            <Container component="main" maxWidth="sm">
            <CssBaseline />
                <Box
                    sx={{
                        mt: 6,
                        mb: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}>
                    <Avatar
                        sx={{ width: 270, height: 207 }}
                        src="https://eventos.cibnor.mx/registro/expociencias/img/logo_expociencias2022.png"
                        variant="square"
                    />
                    <Typography variant="h5"  sx={{ pt: 1 }}>Etapa Estatal</Typography>
                    {/* Inicio del formulario */}
                    <Box
                        component="form"
                        noValidate
                        onSubmit={handleSubmit}
                        sx={{ mt: 3 }}
                        autoComplete="off"
                    >
                        {/* Contenedor general */}
                        <Paper elevation={2} >
                        <Card variant="outlined">
                        <CardContent>
                        {/* Numero de referencia */}
                        <Grid container maxWidth={window.innerWidth} spacing={1}>
                            <Grid item xs={12}>
                                <Typography variant="h6" align="center" sx={{ pb: 2 }}>Por favor ingrese su numero de referencia para recuperar su información
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField 
                                    fullWidth
                                    id="referencia"
                                    inputProps={{ maxLength: 19, style: { textAlign: 'center' }}}
                                    label="Numero de referencia *"
                                    name="referencia"
                                    onChange={handleReferenciaChange}
                                    size="small"
                                    value={referencia}
                                />
                            </Grid>
                        </Grid>
                        </CardContent>
                        </Card>
                        </Paper>
                        {/* Confirma datos */}
                        {/* <Slide direction="up" timeout={600} in={true} > */}
                        <Slide direction="up" timeout={600} in={isRefValid} >
                        <Paper elevation={2}>
                        <Card variant="outlined">
                        <CardContent>
                        <Grid 
                            container 
                            maxWidth={window.innerWidth} 
                            spacing={2} 
                            sx={{ pb: 3 }}
                        >
                            <Grid item xs={12}>
                                <Typography variant="h6" align="center" >Confirme sus datos y agregue su comprobante de pago
                                </Typography>
                            </Grid>
                            {/* Datos del asesor */}
                            <Grid item xs={12} sx={{ml:2, mr:2}} >
                                <TextField
                                    id="asesorNombres"
                                    fullWidth
                                    value={ asesorNombres + " " + asesorApellidos }
                                    helperText={ "<" + asesorCorreo+ ">"}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    variant="standard"
                                />
                            </Grid>
                            <Grid item xs={12} sx={{m:2}} >
                                <TextField
                                    fullWidth
                                    id="proyTitulo"
                                    InputProps={{ readOnly: true }}
                                    label="Nombre del proyecto u obra"
                                    maxRows={12}
                                    minRows={2}
                                    multiline
                                    name="proyTitulo"
                                    size="small"
                                    value={proyTitulo}
                                    variant="standard"
                                />
                            </Grid>
                            {/* Agregar archivo */}
                            <Grid item xs={12}>
                                <TextField
                                    type={"file"}
                                    fullWidth
                                    onChange={e => setFileState(e)}
                                    helperText="Archivo en formato PDF *"
                                    variant="standard"
                                />
                            </Grid>
                            <Grid item xs={8}>
                                <FormControl fullWidth size="small" required>
                                    <InputLabel id="select-regimenfiscal">Forma de pago</InputLabel>
                                    <Select
                                        defaultValue={""}
                                        id="formaPago"
                                        label="Forma de pago"
                                        name="formaPago"
                                        onChange={handleDetallesChange}
                                        value={formaPago}
                                    >
                                        {formasDePago.map(({ value, label }) => (
                                            <MenuItem value={ value } key={ value } >{ label }</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <TextField 
                                    type={"number"}
                                    fullWidth
                                    inputProps={{ style: { textAlign: 'right' }}}
                                    label="Importe *"
                                    id="importe"
                                    name="importe"
                                    size="small"
                                    value={importe}
                                    onChange={handleDetallesChange}
                                />
                            </Grid>
                            {/* Boton */}
                            <Grid item xs={12}>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                endIcon={<SendIcon />}
                            >
                                Enviar
                            </Button>
                            </Grid>
                        </Grid>
                        </CardContent>
                        </Card>
                        </Paper>
                        </Slide>

                        {/* Footer */}
                        <Grid container spacing={2} sx={{ pt: 8, pb: 2 }}>
                            <Grid item xs={12}>
                                <Divider />
                                <Typography gutterBottom sx={{ fontSize:'9px', textDecorationLine: 'none' }} paragraph align="right" color="text.secondary">
                                    <strong>Centro de investigaciones Biológicas del Noroeste S.C.</strong><br />
                                    Instituto Politécnico Nacional 195, Playa Palo de Santa Rita Sur.<br />
                                    La Paz, B.C.S., México; C.P. 23096, Tel:(52) (612) 123-8484<br />
                                    <a href="http://www.cibnor.gob.mx/component/content/article/472" target="_blank" rel="noreferrer" >Política de privacidad</a>
                                </Typography >
                            </Grid>
                        </Grid>
                        {/* Dialog de carga del inicio */}
                        { isLoadingData ? <LoadingDialog /> : '' }
                    </Box>
                    {/* Termina el formulario */}
                </Box>
                {/* Dialogo de espera porque se esta enviando la informacion */}
                <Dialog 
                    open={sendingForm}
                    onClose={handleCloseSendingForm}
                    disableEscapeKeyDown={true}
                    >
                    <DialogTitle id="alert-dialog-title" >
                        {"Por favor, espere..."}
                    </DialogTitle>
                    <DialogContent sx={{
                                    margin: 2,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
                {/* Dialogo de registro cerrado */}
                <CustomDialog 
                    show={true} 
                    title={'Gracias por su interes...'} 
                    content={'Este evento actualmente se encuentra cerrado.'} 
                />
            </Container>
        </ThemeProvider>
    );
};
